<template>
  <v-app>
    <onex-main />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { OnexMain } from '@primerica/onex-ui-lib';
import { useProfileStore } from './stores/profile.store';
import { mapState } from 'pinia';
/*
import type { Composer } from 'vue-i18n';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $t: Composer['t'];
    $d: Composer['d'];
    $n: Composer['n'];
    $tm: Composer['tm'];
  }
}
*/
export default defineComponent({
  name: 'App',
  components: {
    OnexMain,
  },
  computed: {
    ...mapState(useProfileStore, ['profileStore']),
    canGoBack() {
      return false;
    },
    locales(): Record<string, { text: string; value: string }> {
      return this.$t('locales') as unknown as Record<string, { text: string; value: string }>;
    },
  },
  methods: {},
});
</script>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
